import { useGetMenuHeaderQuery } from '@/features/api/endpoints/LayoutEndpoints';
import { Menu } from '@mantine/core';
import { IconHelp } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { Link } from 'react-router-dom';

const UserHelpMenuItem = () => {
  const { t } = useTranslate();
  const { data } = useGetMenuHeaderQuery();

  if (!data || data.status_help !== 'published' || !data.helpLink?.trim() || !data.helpType) {
    return null;
  }

  const helpLink = data.helpLink.trim();

  if (data.helpType === 'external_link') {
    return (
      <Menu.Item
        component="a"
        href={helpLink}
        target="_blank"
        rel="noopener noreferrer"
        leftSection={<IconHelp stroke={1.5} />}
      >
        {t('header.help')}
      </Menu.Item>
    );
  }

  if (data.helpType === 'internal_link') {
    return (
      <Menu.Item component={Link} to={helpLink} leftSection={<IconHelp stroke={1.5} />}>
        {t('header.help')}
      </Menu.Item>
    );
  }

  return null;
};

export default UserHelpMenuItem;
